import "./responsiveImage.scss";

export default function ResponsiveImage({main, mobile, scaling}) {
  let src, width;
  if (window.innerWidth < 800 && mobile && mobile.url) {
    src = mobile.url;
    width = scaling === "regular" ? mobile.dimensions.width : mobile.dimensions.width / 2;
  } else if (window.innerWidth > 799 && main && main.url) {
    src = main.url;
    width = scaling === "regular" ? main.dimensions.width : main.dimensions.width / 2;
  }
  return (
    <section>
      <div className={`article-responsive-image ${scaling}`}>
        <img src={src} width={width} alt=""/>
      </div>
    </section>
  );
}
